/**
 * 门户返回默认配置数据
 */
export const home = [
  {
    styleId:2,
    background: [
      {
        type: 'color',
        isThemeColor : false,
        color: '#f3f3f3',
        label: "颜色"
      }
    ],
    selectBackground: [{
      type: 'color',
      isThemeColor : false,
      color: '#ffffff',
      label: "颜色"
    }],
    rangeInpBackground: [{
      type: 'color',
      isThemeColor : false,
      color: '#f3f3f3',
      label: "颜色"
    }],
    activeBorderRadius: 15,
    activeBorderTopLeftRadius: 15,
    activeBorderTopRightRadius: 15,
    activeBorderBottomLeftRadius: 15,
    activeBorderBottomRightRadius: 15,
    rangeInpFontColor: 'rgba(0,0,0,0.8)',
    borderWidth: 0,
    fontColor: 'rgba(0,0,0,0.8)',
    selectFontColor: 'rgba(0,0,0,0.8)',
    selectBorderColor: "#e9e9e9",
    hoverFontColor: "rgba(0,0,0,1)",
    hoverBgColor: "rgba(43, 103, 255, 0.16)",
    hoverBorderRadius: 20,
    titleColor: "rgb(0,0,0)",
    titleBgColorIsThemeColor: false,
    primaryBtnFontColor: "rgba(255,255,255,1)",
    notCurrentTextColor: "rgba(0,0,0,0.4)",
    activeBgColorIsThemeColor: true,
    lineColor: "#e9e9e9",
    value: "",
  },
  {
    styleId:1,
    dataPickerType:3,
    dateType:"daterange",
    dateFormat:"yyyy-MM-dd",
    value: "",
    background: [
      {
        type: 'color',
        isThemeColor : false,
        color: '#f3f3f3',
        label: "颜色"
      }
    ],
    selectBackground: [{
      type: 'color',
      isThemeColor : false,
      color: '#ffffff',
      label: "颜色"
    }],
    rangeInpBackground: [{
      type: 'color',
      isThemeColor : false,
      color: '#f3f3f3',
      label: "颜色"
    }],
    rangeInpFontColor: 'rgba(0,0,0,0.8)',
    borderWidth: 0,
    fontColor: 'rgba(0,0,0,0.8)',
    selectFontColor: 'rgba(0,0,0,0.8)',
    selectBorderColor: "#e9e9e9",
    hoverFontColor: "rgba(0,0,0,1)",
    hoverBgColor: "rgba(43, 103, 255, 0.16)",
    hoverBorderRadius: 20,
    titleColor: "rgb(0,0,0)",
    titleBgColorIsThemeColor: false,
    primaryBtnFontColor: "rgba(255,255,255,1)",
    notCurrentTextColor: "rgba(0,0,0,0.4)",
    activeBgColorIsThemeColor: true,
    activeBorderRadius: 20,
    lineColor: "#e9e9e9",
  }
]

/**
 * 大屏返回默认配置数据
 */
export const bs = [{
  styleId:1,
  activeBorderRadius: 15,
  activeBorderTopLeftRadius: 15,
  activeBorderTopRightRadius: 15,
  activeBorderBottomLeftRadius: 15,
  activeBorderBottomRightRadius: 15,
  activeBgColorIsThemeColor: true,
  hoverBgColor: "rgba(43, 103, 255, 0.1)",
  hoverBorderRadius: 20,
  titleBgColorIsThemeColor: false,
  titleBgColor: "rgba(0,0,0,0)",
  cancleBtnBorderIsThemeColor: false,
  cancleBtnBorderColor: "rgba(0,0,0,0)",

},{
  styleId:2,
  dataPickerType:3,
  dateType:"daterange",
  dateFormat:"yyyy-MM-dd",
  value: "",
  titleBgColorIsThemeColor: false,
  titleBgColor: "rgba(0,0,0,0)",
  activeBgColorIsThemeColor: true,
  activeBorderRadius: 15,
  cancleBtnBorderIsThemeColor: false,
  cancleBtnBorderColor: "rgba(0,0,0,0)",
},{
  styleId:3,
  dataPickerType:2,
  dateType:"dates",
  dateFormat:"yyyy-MM-dd",
  value: "",
  titleBgColorIsThemeColor: false,
  titleBgColor: "rgba(0,0,0,0)",
  activeBgColorIsThemeColor: true,
  activeBorderRadius: 15,
}]

/**
 * app下拉默认配置数据
 */
export const appHome = [
  {
    styleId: 2,
    background: [
      {
        type: 'color',
        isThemeColor : false,
        color: '#f3f3f3',
        label: "颜色"
      }
    ],
    selectBackground: [{
      type: 'color',
      isThemeColor : false,
      color: '#ffffff',
      label: "颜色"
    }],
    rangeInpBackground: [{
      type: 'color',
      isThemeColor : false,
      color: '#f3f3f3',
      label: "颜色"
    }],
    activeBorderRadius: 15,
    activeBorderTopLeftRadius: 15,
    activeBorderTopRightRadius: 15,
    activeBorderBottomLeftRadius: 15,
    activeBorderBottomRightRadius: 15,
    rangeInpFontColor: 'rgba(0,0,0,0.8)',
    borderWidth: 0,
    fontColor: 'rgba(0,0,0,0.8)',
    selectFontColor: 'rgba(0,0,0,0.8)',
    selectBorderColor: "#e9e9e9",
    hoverFontColor: "rgba(0,0,0,1)",
    hoverBgColor: "rgba(43, 103, 255, 0.16)",
    hoverBorderRadius: 20,
    titleColor: "rgb(0,0,0)",
    titleBgColorIsThemeColor: false,
    primaryBtnFontColor: "rgba(255,255,255,1)",
    notCurrentTextColor: "rgba(0,0,0,0.4)",
    activeBgColorIsThemeColor: true,
    lineColor: "#e9e9e9",
    value: "",
  },
  {
    styleId:1,
    dataPickerType:3,
    dateType:"daterange",
    dateFormat:"yyyy-MM-dd",
    value: "",
    background: [
      {
        type: 'color',
        isThemeColor : false,
        color: '#f3f3f3',
        label: "颜色"
      }
    ],
    selectBackground: [{
      type: 'color',
      isThemeColor : false,
      color: '#ffffff',
      label: "颜色"
    }],
    rangeInpBackground: [{
      type: 'color',
      isThemeColor : false,
      color: '#f3f3f3',
      label: "颜色"
    }],
    rangeInpFontColor: 'rgba(0,0,0,0.8)',
    borderWidth: 0,
    fontColor: 'rgba(0,0,0,0.8)',
    selectFontColor: 'rgba(0,0,0,0.8)',
    selectBorderColor: "#e9e9e9",
    hoverFontColor: "rgba(0,0,0,1)",
    hoverBgColor: "rgba(43, 103, 255, 0.16)",
    hoverBorderRadius: 20,
    titleColor: "rgb(0,0,0)",
    titleBgColorIsThemeColor: false,
    primaryBtnFontColor: "rgba(255,255,255,1)",
    notCurrentTextColor: "rgba(0,0,0,0.4)",
    activeBgColorIsThemeColor: true,
    activeBorderRadius: 20,
    lineColor: "#e9e9e9",
  }
]
